import Name from './Name';
import Id from './Id';
import Failed from './Failed';
import ErrorStatus from './ErrorStatus';
import ErrorStage from './ErrorStage';
import ErrorMessage from './ErrorMessage';
export default {
  install(molten) {
    molten.addPlugin('Attribute', Name);
    molten.addPlugin('Attribute', Id);
    molten.addPlugin('Attribute', Failed);
    molten.addPlugin('Attribute', ErrorStatus);
    molten.addPlugin('Attribute', ErrorStage);
    molten.addPlugin('Attribute', ErrorMessage);
  }
};